import { gql } from '@apollo/client'
import { useMutation } from 'src/services/apollo'
import { IUseMutationOptions } from 'src/services/apollo/Mutation/useMutation'
import {
  OnboardingQualificationInstanceAttachmentUpdate,
  OnboardingQualificationInstanceAttachmentUpdateVariables,
} from './__gql__/useOnboardingQualificationInstanceAttachmentUpdateCodeGen'

const ONBOARDING_QUALIFICATION_INSTANCE_ATTACHMENT_UPDATE = gql`
  mutation OnboardingQualificationInstanceAttachmentUpdate(
    $documentId: ID!
    $uploadStatus: PersonDocumentUploadStatus
    $displayName: String
    $folderId: String
  ) {
    onboardingQualificationInstanceAttachmentUpdate(
      input: { documentId: $documentId, uploadStatus: $uploadStatus, displayName: $displayName, folderId: $folderId }
    ) {
      document {
        id
        uploadStatus
        displayName
        extension
        size
        humanReadableSize
        createdAt
        createdAtTimestamp: createdAtDateTime
        createdAtDateTime
        downloadUrl
        downloadUrlAbsolute
        personId
        folderId
        category
        sourceSystem
      }
    }
  }
`

const useOnboardingQualificationInstanceAttachmentUpdate = (
  options?: IUseMutationOptions<
    OnboardingQualificationInstanceAttachmentUpdate,
    OnboardingQualificationInstanceAttachmentUpdateVariables
  >,
) => {
  return useMutation<
    OnboardingQualificationInstanceAttachmentUpdate,
    OnboardingQualificationInstanceAttachmentUpdateVariables
  >(ONBOARDING_QUALIFICATION_INSTANCE_ATTACHMENT_UPDATE, {
    ...options,
  })
}

export { useOnboardingQualificationInstanceAttachmentUpdate }
